/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".txt[_ngcontent-%COMP%]{color:#303372;font-weight:700;font-size:20px}section[_ngcontent-%COMP%]{padding:16px}button[_ngcontent-%COMP%]{border:2px solid #0a60a9;border-radius:4px;height:40px;text-align:center;padding-left:16px;padding-right:16px;cursor:pointer;background:rgba(255,255,255,.4);color:#8d8c8c;line-height:0}button.active[_ngcontent-%COMP%], button[_ngcontent-%COMP%]:hover{background:#0a60a9;color:#fff}"];
export { styles as styles };
